<template>
  <div id="spookynook-activenet-schedules-widget" :class="{ 'ios-mobile': isIosMobile }">
    <SchedulesFiltersBar
      v-if="initialDataLoaded"
      :filters-options="filtersOptions"
      :initial-filters="initialFilters"
      :page="page"
      :date-results="dateResults"
      @filters-changed="FilterChanged"
    />
    <SchedulesResults
      :results-number="count"
      :results="results"
      :show-preloader="showPreloader"
      :date="filtersQuery.date"
      :no-result-url="noResultUrl"
      @date-change="ResultsDateChange"
    />
    <AppPagination :total-pages="total_pages" :current-page="page" @page-change="PageChanged" />
  </div>
</template>

<script>
import { getSchedulesData, getFilteredSchedulesData } from './api/filter.api.ts'
import SchedulesFiltersBar from './components/SchedulesFiltersBar'
import SchedulesResults from './components/SchedulesResults'
import AppPagination from './components/AppPagination'

export default {
  components: {
    SchedulesFiltersBar,
    SchedulesResults,
    AppPagination
  },
  data() {
    return {
      filtersOptions: {
        date: '',
        location: [],
        categories: []
      },
      initialFilters: {
        date: '',
        location: [],
        categories: []
      },
      initialDataLoaded: false,
      showPreloader: true,
      results: [],
      baseUrl: this.$root.$data.baseUrl + '/api/schedules',
      filtersQuery: {},
      count: 0,
      page: 0,
      total_pages: 0,
      dateResults: null, // To track date change in Result component -> Filters Component
      noResultUrl: 'https://www.spookynooksports.com/manheim/email-sign-up'
    }
  },
  created() {
    this.GetInitData()
  },
  methods: {
    async GetInitData() {
      // Query for program specific
      const query = {
        organization: this.$root.$data?.organization
      }
      const [error, response] = await getSchedulesData(this.baseUrl, query)
      const facets = response.facets

      if (error) console.log(error)
      else {
        this.filtersOptions.location = facets.locations
        this.filtersOptions.categories = facets.categories
        this.filtersOptions.date = response.date // To delete
        this.initialFilters.date = response.date

        this.count = response.count
        this.results = response.table
        this.total_pages = response.total_pages

        this.ParseQuery()

        await this.FetchFilteredData(this.initialFilters)
        if (this.$root.$data?.organization === 'spookynooksportsohio') {
          this.noResultUrl = 'https://www.spookynooksports.com/hamilton/email-sign-up'
        }
        this.initialDataLoaded = true
      }
    },
    async FetchFilteredData(queryToPush) {
      if (queryToPush) this.filtersQuery = queryToPush

      // Restructure query with filters id
      const query = {}

      for (let [key, param] of Object.entries(this.filtersQuery)) {
        if (Array.isArray(param)) {
          if (param.length) {
            query[key] = this.filtersQuery[key].map((i) => i.id)
          }
        } else if (param) query[key] = param
      }
      query.page = this.page
      query.organization = this.$root.$data?.organization

      // Push query to url
      this.$router.push({ query: query }).catch(() => {})

      // Fetch data
      this.showPreloader = true
      const [error, response] = await getFilteredSchedulesData(this.baseUrl, query)

      if (error) console.log(error)
      else {
        this.count = response.count
        this.results = response.table
        this.total_pages = response.total_pages
        this.showPreloader = false
      }
    },
    ParseQuery() {
      for (let [key, param] of Object.entries(this.$route.query)) {
        if (Array.isArray(param)) {
          // Parse array to multiple select.
          param.forEach((item) => {
            ;(this.initialFilters[key] || []).push(
              this.filtersOptions[key].find((option) => option.id === item)
            )
          })
        } else if (Array.isArray(this.filtersOptions[key]) && param) {
          // Parse single value to multiple select.
          // Waiting async prop filtersOptions from parent component
          if (this.filtersOptions[key].length)
            (this.initialFilters[key] || []).push(
              this.filtersOptions[key].find((option) => option.id === param)
            )
        } else if (param) this.initialFilters[key] = param
      }
      this.page = parseInt(this.$route.query.page) || 0
      delete this.initialFilters.page
    },
    ResultsDateChange(resultsDate) {
      this.dateResults = resultsDate
    },
    PageChanged(currentPage) {
      this.page = currentPage
      this.FetchFilteredData(this.filtersQuery)
    },
    FilterChanged(filters) {
      this.page = 0
      this.filtersQuery = JSON.parse(JSON.stringify(filters))
      this.FetchFilteredData(this.filtersQuery)
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Noto+Sans:wght@400;700&display=swap');

#spookynook-activenet-schedules-widget {
  font-family: $font-main;
  line-height: 1;
  color: $color-black;
  margin-bottom: 40px;

  h1,
  .h1,
  h2,
  .h2,
  h3,
  .h3,
  h4,
  .h4,
  h5,
  .h5 {
    font-family: $font-secondary !important;
    font-weight: normal;
  }

  h5,
  .h5 {
    font-size: rem(18);
    line-height: rem(21);

    @include media-breakpoint-up(lg) {
      font-size: rem(20);
      line-height: rem(24);
    }
  }
}
</style>
